import Vue from 'vue'
import Router from 'vue-router'
import firebase from "firebase";
// コンポーネント
import login from '../components/login/login.vue'
import dashboard from '../components/aftersale/dashboard/summary.vue'
import predict from '../components/aftersale/predict/predict.vue'
import setting from '../components/aftersale/setting/setting.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      component: login
    }, {
      path: '/dashboard',
      component: dashboard,
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/predict',
      component: predict,
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/setting',
      component: setting,
      meta: {
        requiresAuth: true
      }
    }
  ]
})

// ログイン認証はここで行う
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        next()
      } else {
        next({
          path: '/'
        })
      }
    })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js